import React from 'react';
import { Button } from 'Common/components/Atoms/Button';
import { Div } from 'Common/components/Atoms/Div';
import { Flex } from 'Common/components/Atoms/Flex';
import { Text } from 'Common/components/Atoms/Text';
import { ProviderIcon } from 'Common/components/Molecules/ProviderIcon';
import { Link } from 'Common/components/Atoms/Link';
import StepIcon from '../StepIcon';
import { useTheme } from '@mui/material';
import { generators } from 'stores/oauth/generators';
import { useDispatch } from 'react-redux';

const RightPane = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const signUpCode = 'H1SECURITY';
  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      width="60%"
      pt={10}
      pb={4}
      boxSizing="border-box"
      backgroundColor={theme.palette.background.default}
    >
      <Div textAlign="left" width={480}>
        <Text variant="h2" my={1}>
          Get started for free.
        </Text>
        <Text fontSize="1rem" my={1}>
          Your first five reviews are on us!
        </Text>
        <Flex mt={4} alignItems="flex-start">
          <StepIcon active={true} borderlineheight={190}>
            <Text variant="h3">1</Text>
          </StepIcon>
          <Flex flexDirection="column" ml={4}>
            <Text variant="h3">
              Seamlessly integrate your code review workflow
            </Text>
            <Button
              onClick={() =>
                dispatch(
                  generators.handleOauthRedirect.request({
                    provider: 'github',
                    signUpCode,
                  })
                )
              }
              variant="contained"
              height={50}
              width={330}
              mt={4}
            >
              <ProviderIcon
                provider="github"
                style={{ position: 'absolute', left: '16px' }}
                color={theme.palette.common.white}
                size="2x"
              />
              GitHub
            </Button>
            <Button
              onClick={() =>
                dispatch(
                  generators.handleOauthRedirect.request({
                    provider: 'gitlab',
                    signUpCode,
                  })
                )
              }
              variant="contained"
              height={50}
              width={330}
              mt={1}
            >
              <ProviderIcon
                provider="gitlab"
                style={{ position: 'absolute', left: '16px' }}
                color={theme.palette.common.white}
                size="2x"
              />
              GitLab
            </Button>
            <Text mt={4}>
              Or:{' '}
              <Link
                onClick={() =>
                  dispatch(
                    generators.handleOauthRedirect.request({
                      provider: 'bitbucket',
                      signUpCode,
                    })
                  )
                }
              >
                Bitbucket
              </Link>{' '}
              |{' '}
              <Link
                onClick={() =>
                  dispatch(
                    generators.handleOauthRedirect.request({
                      provider: 'azuredevops',
                      signUpCode,
                    })
                  )
                }
              >
                Azure DevOps
              </Link>{' '}
              |{' '}
              <Link
                onClick={() =>
                  dispatch(
                    generators.handleOauthRedirect.request({
                      provider: 'hackerone',
                      signUpCode,
                    })
                  )
                }
              >
                HackerOne
              </Link>
            </Text>
          </Flex>
        </Flex>
        <Flex mt={4} center>
          <StepIcon active={false} borderlineheight={32}>
            <Text color="textSecondary" variant="h3">
              2
            </Text>
          </StepIcon>
          <Text color="textSecondary" variant="h3" ml={4}>
            Select a pull or merge request that intends to fix a security
            vulnerability
          </Text>
        </Flex>
        <Flex mt={6} center>
          <StepIcon active={false}>
            <Text color="textSecondary" variant="h3">
              3
            </Text>
          </StepIcon>
          <Text color="textSecondary" variant="h3" ml={4}>
            Within a few hours, receive a review from a senior security engineer
          </Text>
        </Flex>
        <Flex justifyContent="center" width="100%">
          <Div
            my={6}
            mx={4}
            width="40%"
            borderTop={`1px solid ${theme.palette.divider}`}
          />
        </Flex>
        <Text variant="caption" mb={4}>
          Trust means everything to us. We will never use your provider without
          your explicit permission.
        </Text>
        <Text variant="caption" mt={4}>
          By signing up, you agree to abide by our{' '}
          <Link href="https://www.pullrequest.com/terms/">
            Terms of Service
          </Link>{' '}
          and{' '}
          <Link href="https://www.pullrequest.com/privacy/">
            Privacy Policy.
          </Link>
        </Text>
      </Div>
    </Flex>
  );
};

export default RightPane;
